/*
  chapter-helper.js

  A local helper to set display props
  for chapter items.

  Author: Tim Bauwens
  Copyright: xxllnc 2022
*/

import { getCurrentChapterID } from "$json/lib/getcurrentchapterid";
import { getmetadata } from "$json/lib/getmetadata";
import { state } from "$json/lib/store";
import { has } from "$json/lib/functional";
import { CONFIG as scrollconfig } from "../../../../plugins/auto-scroll/auto-scroll";

((_win, doc, $) => {
  var lastKnownScrollPos = 0;

  const applystate = () => {
    if (state.has("p-chapters-helper")) {
      let saved = state.get("p-chapters-helper");
      let toshow = saved.toshow || [];
      bb.Mode.toggle("hasSpecialChapters", Boolean(toshow.length));
      let currentChapter = saved.currentChapter || "";
      let jl = doc.querySelector(".bb-jumplist ul");
      if (jl !== null) {
        jl.querySelectorAll("li").forEach(chapter => {
          let title = chapter
            .querySelector("button > span")
            .innerText.replace(/\s/g, "");

          let bgpath = has("finalScore")(
            chapter.querySelector("button[data-groupid]").dataset
          )
            ? `url('../../rijks-cyberscan/plugins/chapters-helper/live/chapter_icons/${title}Actief.svg?v=20230117')`
            : `url('../../rijks-cyberscan/plugins/chapters-helper/live/chapter_icons/${title}Normaal.svg?v=20230117')`;

          let ariaLabel = has("finalScore")(
            chapter.querySelector("button[data-groupid]").dataset
          )
            ? chapter.querySelector("button[data-groupid]").dataset
                .finalScore == 1
              ? "Voltooid"
              : `Huidige stap`
            : `Nog niet voltooid`;

          let selected =
            chapter
              .querySelector("button[data-groupid]")
              .getAttribute("data-groupid") === currentChapter
              ? true
              : false;

          chapter.classList.toggle("show", toshow.includes(title));
          chapter.setAttribute("aria-hidden", !toshow.includes(title));
          chapter.setAttribute("aria-label", ariaLabel);
          chapter.classList.toggle("selected", selected);
          chapter.style.setProperty("--bg", bgpath);
        });
      }
      let actielijstID = saved.actielijstID || false;
      let btn = doc.querySelector("nav button.actielijst");
      if (actielijstID) {
        btn.setAttribute("value", actielijstID);
        btn.dataset.groupid = actielijstID;
      } else {
        btn.setAttribute("value", "");
        btn.dataset.groupid = "";
      }
    }
  };

  $(doc).on("bb:stateChange", () => {
    applystate();
  });

  $(doc).on("bb:preHandleData", (_e, data) => {
    if (data && data.groups && data.groups.length) {
      lastKnownScrollPos = doc.querySelector(".column--chapters").scrollTop;
    }
  });

  $(doc).on("bb:postHandleData", (_e, data) => {
    if (data && data.groups && data.groups.length) {
      let saved = state.has("p-chapters-helper")
        ? state.get("p-chapters-helper")
        : {};
      saved.currentChapter = getCurrentChapterID(data.groups);
      if (!has("chaptermap")(saved)) saved.chaptermap = {};
      const props = getmetadata(data).props;
      if (props.has("p-chapters-helper-show")) {
        let toshow = props.get("p-chapters-helper-show").split("|");
        saved.toshow = toshow.map(title => title.replace(/\s/g, ""));
        saved.toshow = saved.toshow.filter(title => title !== "false");
      }
      if (props.has("p-chapters-helper-chapterid")) {
        saved.chaptermap[props.get("p-chapters-helper-chapterid")] =
          saved.currentChapter;
      }

      state.set("p-chapters-helper", saved);

      // A small helper for the auto-scroll in case of small window size:
      if (window.innerWidth <= 943) {
        scrollconfig.props = { selector: ".l-content--left" };
      } else {
        scrollconfig.props = "default";
      }
    }
  });

  $(doc).on("bb:finalHandleData", (_e, data) => {
    if (data && data.groups && data.groups.length) {
      applystate();
      // Finally, scroll the jumplist to the right place.
      //let currentChapter = doc.querySelector(".bb-jumplist li.selected");
      let scrollSection = doc.querySelector(".column--chapters");
      scrollSection.scrollTo(0, lastKnownScrollPos);

      /*
        The desired scroll Y pos is the half the
        height of the column minus the selected
        icons total height offset (plus half 
        it's own height).
      */
      let height = scrollSection.offsetHeight;
      let middle = height / 2;
      let posInList = Array.from(doc.querySelectorAll(".bb-jumplist li.show"))
        .map(item => item.className.includes("selected"))
        .indexOf(true);
      let avgIconHeight = 110; // Guestimate magic number.
      let currentChapterIconOffset =
        avgIconHeight * posInList + avgIconHeight / 2;
      let desiredY = -1 * (middle - currentChapterIconOffset);

      window.setTimeout(e => {
        // Scroll to the desiredY
        scrollSection.scrollTo({
          top: desiredY,
          left: 0,
          behavior: "smooth"
        });
      }, 100);
    }
  });
})(window, document, jQuery);
